<template>
  <div class="pb-3">
    <div class="dashboard__row-2">
      <div class="row-2__item-1">
        <!-- TICKET TRACKING PRIORITY START -->
        <molecule-dashboard-container
          title="Ticket Tracking (Priority)"
          :isLoading="isLoadingTicketPriority"
          class="mb-1"
        >
          <template #body>
            <div
              class="d-flex justify-content-between align-items-center w-100"
            >
              <div class="position-relative">
                <div class="position-absolute ticket-priority__count">
                  <div class="d-flex flex-column align-items-center">
                    <label class="ticket-priority__text-count">{{
                      ticketPriorityCount
                    }}</label>
                    <label class="ticket-priority__text">Ticket</label>
                  </div>
                </div>
                <atom-doughnut-chart-v-2
                  radius="100%"
                  innerRadius="70%"
                  :isTextInner="false"
                  :isShowTextCenterWhenHover="false"
                  :dataList="ticketPriorityList"
                  width="120px"
                  height="120px"
                ></atom-doughnut-chart-v-2>
              </div>
              <div class="ml-2">
                <div
                  v-for="({ value, name }, index) in ticketPriorityList"
                  :key="index"
                  class="d-flex justify-content-between"
                >
                  <label class="ticket-priority__text-value">{{ value }}</label>
                  <label class="ticket-priority__text-name ml-1">{{
                    name
                  }}</label>
                </div>
              </div>
            </div>
          </template>
        </molecule-dashboard-container>
        <!-- TICKET TRACKING PRIORITY END -->

        <!-- STATUS COUNT START -->
        <div
          v-for="(statusCount, index) of statusCountList"
          :key="index"
          class="mb-1"
        >
          <molecule-dashboard-container
            :title="getStatusCountTitleOrIcon(statusCount.name)"
            :icon="getStatusCountTitleOrIcon(statusCount.name, true)"
            :isLoading="statusCount.isLoading"
            :isBgHeader="true"
            class="status-count__card"
          >
            <template #body>
              <div
                class="d-flex justify-content-around justify-content-md-between w-100 mt-1"
              >
                <div>
                  <p class="text-status-count">
                    {{
                      statusCount.name === "contract"
                        ? "Waiting for Approval"
                        : statusCount.name === "ticket"
                        ? "Open"
                        : "Waiting"
                    }}
                  </p>
                  <p class="mb-0 text-count-open">
                    {{ statusCount.open || statusCount.waiting || 0 }}
                  </p>
                </div>
                <div v-if="statusCount.name !== 'contract'">
                  <p class="text-status-count">
                    {{
                      statusCount.name === "access"
                        ? "Approved"
                        : statusCount.name === "parcel"
                        ? "Received"
                        : "In Progress"
                    }}
                  </p>
                  <p class="mb-0 text-count-in-progress">
                    {{
                      statusCount.inProgress ||
                      statusCount.approved ||
                      statusCount.received ||
                      0
                    }}
                  </p>
                </div>
              </div>
            </template>
          </molecule-dashboard-container>
        </div>
        <!-- STATUS COUNT END -->

        <!-- INVENTORY MA DATE START -->
        <!-- <molecule-dashboard-container
          title="Inventory MA Date"
          :isLoading="isLoadingInventory"
          :isHasBodyPadding="false"
          class="mb-1"
        >
          <template #body>
            <div class="container__body w-100 height-inventory">
              <div
                v-if="!inventoryList.item.length"
                class="d-flex flex-column align-items-center justify-content-center h-100"
              >
                <feather-icon icon="CloudOffIcon" class="icon_folder" />
                No Inventory
              </div>
              <div v-else class="d-flex mb-1">
                <b-badge pill variant="light-primary">
                  <span class="font-size-10">
                    {{ inventoryList.count.all }} All
                  </span>
                </b-badge>
                <b-badge
                  pill
                  variant="light-warning"
                  class="custom-margin-left-6"
                >
                  <span class="font-size-10">
                    {{ inventoryList.count.expireSoon }} Expire Soon
                  </span>
                </b-badge>
                <b-badge
                  pill
                  variant="light-danger"
                  class="custom-margin-left-6"
                >
                  <span class="font-size-10">
                    {{ inventoryList.count.expired }} Expired
                  </span>
                </b-badge>
              </div>
              <div
                v-for="(inventory, index) of inventoryList.item"
                :key="index"
                class="w-100"
              >
                <div class="d-flex w-100 justify-content-between">
                  <div class="d-flex flex-column mr-1">
                    <label class="text-inventory-subject mb-0">Name</label>
                    <label class="text-inventory-name mb-0">
                      {{ inventory.name }}
                    </label>
                    <label class="text-inventory-type mb-0">
                      ({{ inventory.type }})
                    </label>
                  </div>

                  <div class="d-flex flex-column align-items-end">
                    <label class="text-inventory-subject mb-0"
                      >MA Last Date</label
                    >
                    <label
                      class="text-inventory-ma-date mb-0"
                      :class="[
                        inventory.status === 'EXPIRED'
                          ? 'text-color-danger'
                          : 'text-color-warning',
                      ]"
                      >{{ inventory.maLastDate || "-" }}</label
                    >
                    <b-badge
                      variant="light-dark"
                      class="badge--width text-size-12"
                    >
                      {{ inventory.siteName || "Site Not Found" }}
                    </b-badge>
                  </div>
                </div>

                <hr />
              </div>
            </div>
          </template>
        </molecule-dashboard-container> -->
        <!-- INVENTORY MA DATE END -->
      </div>
      <div class="row-2__item-2">
        <!-- NEW ENTRY START -->
        <molecule-dashboard-container
          title="10 New Entry"
          :isLoading="isLoadingNewEntry"
          :isHasBodyPadding="false"
          classHeaderLayout="d-lg-flex"
          class="mb-1"
        >
          <template #header>
            <b-button-group class="mt-1 mt-lg-0 width-md-100">
              <b-button
                v-for="(menu, index) of buttonMenuName"
                :key="index"
                :variant="getVariantMenuNewEntry(menu.name)"
                @click="selectNewEntry = menu.name"
                class="height-button-group"
                >{{ menu.topic }}</b-button
              >
            </b-button-group>
          </template>

          <template #body>
            <div class="container__body w-100 height-new-entry">
              <div
                v-if="
                  !newEntryList.get(selectNewEntry) ||
                  !newEntryList.get(selectNewEntry).length
                "
                class="d-flex flex-column align-items-center justify-content-center h-100"
              >
                <feather-icon icon="CloudOffIcon" class="icon_folder" />
                No New Entry
              </div>
              <div
                v-for="(newEntry, index) of newEntryList.get(selectNewEntry)"
                :key="index"
                class="w-100"
              >
                <div
                  class="d-md-flex w-100 justify-content-between entry__item py-1"
                  @click="clickRow(selectNewEntry, newEntry)"
                >
                  <div class="d-flex flex-column col-12 col-md-4 pl-0">
                    <label class="text-company">{{
                      newEntry.companyName
                    }}</label>
                    <label class="text-idc">{{
                      `${contractIdLabel}: ${newEntry.idcId || "-"}`
                    }}</label>
                    <label class="text-idc">{{
                      newEntry.idLabel || newEntry.id || ""
                    }}</label>
                  </div>
                  <div
                    class="d-flex justify-content-between col-12 col-md-8 px-0 mt-1 mt-md-0"
                  >
                    <div class="d-flex flex-column">
                      <label
                        v-for="(middle, i) of getNewEntryMiddleColumnList(
                          newEntry
                        )"
                        :key="i"
                        class="text-normal"
                      >
                        {{ middle }}</label
                      >
                    </div>
                    <div class="d-flex flex-column align-items-end">
                      <label class="text-date">{{ newEntry.date }}</label>
                      <div class="d-flex align-items-center">
                        <div :id="'new-entry-date-' + index" class="d-flex">
                          <feather-icon
                            icon="InfoIcon"
                            size="12"
                            class="alert__icon alert__icon-info"
                          />
                        </div>
                        <b-tooltip
                          :target="'new-entry-date-' + index"
                          placement="left"
                          boundary="window"
                          variant="primary"
                        >
                          <div class="description__container">
                            <div>Created date</div>
                          </div>
                        </b-tooltip>
                        <label class="text-time">{{ newEntry.time }}</label>
                      </div>
                      <b-badge
                        variant="light-dark"
                        class="badge--width text-size-12"
                      >
                        {{ newEntry.siteName || "Site Not Found" }}
                      </b-badge>
                    </div>
                  </div>
                </div>

                <hr class="my-0" />
              </div>
            </div>
          </template>
        </molecule-dashboard-container>
        <!-- NEW ENTRY END -->
      </div>
    </div>

    <!-- TICKET ESCALATION START -->
    <molecule-dashboard-container
      title="Ticket Escalation"
      :isLoading="isLoadingTicketEscalation"
      :isHasBodyPadding="false"
      class="mb-1"
    >
      <template #body>
        <div class="container__body w-100">
          <div
            v-if="!ticketEscalationList.length"
            class="d-flex flex-column align-items-center justify-content-center h-100"
          >
            <feather-icon icon="CloudOffIcon" class="icon_folder" />
            No Ticket Escalation
          </div>
          <div
            v-for="(ticketEscalation, index) of ticketEscalationList"
            :key="index"
            class="w-100"
          >
            <div
              class="d-md-flex w-100 justify-content-between entry__item py-1"
              @click="clickRowTicketEscalation(ticketEscalation)"
            >
              <div
                class="d-flex justify-content-between col-12 col-md-2 px-0 pr-md-1"
              >
                <div class="d-flex flex-column">
                  <label class="text-company">{{
                    ticketEscalation.companyName
                  }}</label>
                  <label class="text-idc">{{
                    `${contractIdLabel}: ${ticketEscalation.idcId || "-"}`
                  }}</label>
                  <label class="text-idc">{{
                    ticketEscalation.idLabel || ticketEscalation.id || ""
                  }}</label>
                </div>
              </div>

              <div
                class="d-flex flex-column col-12 col-md-3 px-0 pr-md-1 mt-1 mt-md-0"
              >
                <label
                  v-for="(
                    subjectAndLastReply, subjectIndex
                  ) of getEscalationSubjectAndLastReply(ticketEscalation)"
                  :key="subjectIndex"
                  class="text-normal"
                >
                  {{ subjectAndLastReply }}
                </label>
              </div>

              <div
                class="d-flex flex-column col-12 col-md-3 px-0 pr-md-1 mt-1 mt-md-0"
              >
                <div class="d-flex">
                  <label
                    v-for="(
                      escalateLevel, levelIndex
                    ) of getEscalationEscalateLevel(ticketEscalation)"
                    :key="levelIndex"
                    class="text-normal"
                  >
                    {{ escalateLevel }}
                  </label>
                  <div
                    v-if="ticketEscalation.isUserLevel"
                    :id="'ticket-escalated-level-' + index"
                    class="d-flex"
                  >
                    <feather-icon
                      icon="AlertTriangleIcon"
                      size="18"
                      class="alert__icon alert__icon-level"
                    />
                  </div>
                  <b-tooltip
                    v-if="ticketEscalation.isUserLevel"
                    :target="'ticket-escalated-level-' + index"
                    placement="right"
                    boundary="window"
                    variant="warning"
                  >
                    <div class="description__container">
                      <div class="textbox__warning-value--style">
                        Your Level!
                      </div>
                    </div>
                  </b-tooltip>
                </div>
                <label
                  v-for="(escalate, escalateIndex) of getEscalateColumnList(
                    ticketEscalation
                  )"
                  :key="escalateIndex"
                  class="text-normal"
                >
                  {{ escalate }}
                </label>
              </div>

              <div
                class="d-flex justify-content-between align-items-start col-12 col-md-3 px-0 mt-1 mt-md-0"
              >
                <div>
                  <b-badge
                    pill
                    :variant="getVariantForStatus(ticketEscalation.status)"
                    >{{ getStatus(ticketEscalation.status) }}</b-badge
                  >
                </div>

                <div class="d-flex flex-column align-items-end">
                  <label class="text-date">{{ ticketEscalation.date }}</label>
                  <div class="d-flex align-items-center">
                    <div :id="'ticket-escalated-date-' + index" class="d-flex">
                      <feather-icon
                        icon="InfoIcon"
                        size="12"
                        class="alert__icon alert__icon-info"
                      />
                    </div>
                    <b-tooltip
                      :target="'ticket-escalated-date-' + index"
                      placement="left"
                      boundary="window"
                      variant="primary"
                    >
                      <div class="description__container">
                        <div>Escalated date</div>
                      </div>
                    </b-tooltip>
                    <label class="text-time">{{ ticketEscalation.time }}</label>
                  </div>
                  <b-badge
                    variant="light-dark"
                    class="badge--width text-size-12"
                  >
                    {{ ticketEscalation.siteName || "Site Not Found" }}
                  </b-badge>
                </div>
              </div>
            </div>
            <hr class="my-0" />
          </div>
        </div>
      </template>
    </molecule-dashboard-container>
    <!-- TICKET ESCALATION END -->

    <!-- RECENT CHANGE START -->
    <molecule-dashboard-container
      title="10 Recent Change"
      :isLoading="isLoadingRecentChange"
      :isHasBodyPadding="false"
      class="mb-1"
    >
      <template #header>
        <b-button-group class="mt-1 mt-md-0 width-sm-100">
          <b-button
            v-for="(menu, index) of buttonMenuName"
            :key="index"
            :variant="getVariantMenuRecentChange(menu.name)"
            @click="selectRecentChange = menu.name"
            class="height-button-group"
            >{{ menu.topic }}</b-button
          >
        </b-button-group>
      </template>

      <template #body>
        <div class="container__body w-100">
          <div
            v-if="
              !recentChangeList.get(selectRecentChange) ||
              !recentChangeList.get(selectRecentChange).length
            "
            class="d-flex flex-column align-items-center justify-content-center h-100"
          >
            <feather-icon icon="CloudOffIcon" class="icon_folder" />
            No Recent Change
          </div>
          <div
            v-for="(recentChange, index) of recentChangeList.get(
              selectRecentChange
            )"
            :key="index"
            class="w-100"
          >
            <div
              class="d-md-flex w-100 justify-content-between entry__item py-1"
              @click="clickRow(selectRecentChange, recentChange)"
            >
              <div
                class="d-flex justify-content-between col-12 col-md-4 px-0 pr-md-1"
              >
                <div class="d-flex flex-column">
                  <label class="text-company">{{
                    recentChange.companyName
                  }}</label>
                  <label class="text-idc">{{
                    `${contractIdLabel}: ${recentChange.idcId || "-"}`
                  }}</label>
                  <label class="text-idc">{{
                    recentChange.idLabel || recentChange.id || ""
                  }}</label>
                </div>
                <div
                  v-if="recentChange.priority"
                  class="priority-container"
                  :class="`priority__${recentChange.priority.toLowerCase()}`"
                >
                  {{ recentChange.priority }}
                </div>
              </div>

              <div
                class="d-md-flex justify-content-between col-12 col-md-8 px-0 mt-1 mt-md-0"
              >
                <div class="d-flex flex-column col-12 col-md-8 px-0">
                  <label
                    v-for="(middle, i) of getRecentChangeMiddleColumnList(
                      recentChange
                    )"
                    :key="i"
                    class="text-normal"
                  >
                    {{ middle }}
                  </label>
                </div>

                <div
                  class="d-flex justify-content-between align-items-start col-12 col-md-4 px-0 mt-1 mt-md-0"
                >
                  <div>
                    <b-badge
                      pill
                      :variant="
                        selectRecentChange === 'access' ||
                        selectRecentChange === 'parcel'
                          ? getVariantForStatusParcel(recentChange.status)
                          : getVariantForStatus(recentChange.status)
                      "
                      style=""
                      >{{ getStatus(recentChange.status) }}</b-badge
                    >
                  </div>
                  <div class="d-flex flex-column align-items-end">
                    <label class="text-date">{{ recentChange.date }}</label>
                    <div class="d-flex align-items-center">
                      <div :id="'recent-change-date-' + index" class="d-flex">
                        <feather-icon
                          icon="InfoIcon"
                          size="12"
                          class="alert__icon alert__icon-info"
                        />
                      </div>
                      <b-tooltip
                        :target="'recent-change-date-' + index"
                        placement="left"
                        boundary="window"
                        variant="primary"
                      >
                        <div class="description__container">
                          <div>Updated date</div>
                        </div>
                      </b-tooltip>
                      <label class="text-time">{{ recentChange.time }}</label>
                    </div>
                    <b-badge
                      variant="light-dark"
                      class="badge--width text-size-12"
                    >
                      {{ recentChange.siteName || "Site Not Found" }}
                    </b-badge>
                  </div>
                </div>
              </div>
            </div>

            <hr class="my-0" />
          </div>
        </div>
      </template>
    </molecule-dashboard-container>
    <!-- RECENT CHANGE END -->

    <!-- NEW ENTRY STATISTIC START -->
    <molecule-dashboard-container
      title="New Entry Statistics"
      :isLoading="isLoadingEntryStat"
      :isHasBodyPadding="false"
      class="mb-1"
    >
      <template #header>
        <div
          class="d-sm-flex justify-content-md-end align-items-center mt-1 mt-md-0"
        >
          <div class="d-lg-flex align-items-lg-center w-100">
            <label class="d-sm-none">From</label>
            <atom-datepicker
              v-model="graphStatPeriod.startDate"
              datepickerId="graph-stat-period-start"
              type="dateNtime"
              placeholder="Select Start Date"
              :maxDate="
                graphStatPeriod.endDate
                  ? graphStatPeriod.endDate
                  : graphStatPeriod.now
              "
              :isError="!graphStatPeriod.startDate"
              errorMessage="Please Select Start Date"
              @onChangeDatetime="onChangeEntryStatTime"
            ></atom-datepicker>
          </div>

          <div class="mx-sm-1 d-none d-sm-flex">
            <label>-</label>
          </div>

          <div class="d-lg-flex align-items-lg-center mt-1 mt-sm-0 w-100">
            <label class="d-sm-none">To</label>
            <atom-datepicker
              v-model="graphStatPeriod.endDate"
              datepickerId="graph-stat-period-end"
              type="dateNtime"
              placeholder="Select End Date"
              :minDate="graphStatPeriod.startDate"
              :maxDate="graphStatPeriod.now"
              :isError="!graphStatPeriod.endDate"
              errorMessage="Please Select End Date"
              @onChangeDatetime="onChangeEntryStatTime"
            ></atom-datepicker>
          </div>
        </div>
      </template>
      <template #body>
        <div class="container__body w-100 pb-2 height-graph overflow-hidden">
          <atom-multi-line-chart
            :timestampList="entryStatTimestampList"
            :dataList="entryStatDataList"
          ></atom-multi-line-chart>
        </div>
      </template>
    </molecule-dashboard-container>
    <!-- NEW ENTRY STATISTIC END -->

    <!-- IDC DATABASE START -->
    <molecule-dashboard-container
      :title="databaseTitle"
      :isLoading="isLoadingIdc"
      :isHasBodyPadding="false"
      :badgeText="badgeText"
      badgeVariant="light-info"
      class="mb-1"
    >
      <template #header>
        <b-button-group class="mt-1 mt-md-0 width-sm-100">
          <b-button
            v-for="(menu, index) of buttonMenuIdcName"
            :key="index"
            :variant="getVariantMenuIdc(menu.name)"
            @click="onChangeIdcType(menu.name)"
            class="height-button-group"
            >{{ menu.topic }}</b-button
          >
        </b-button-group>
      </template>

      <template #body>
        <div class="px-0 pb-2 w-100">
          <div class="row">
            <div class="col-12">
              <div class="card-padding organism-idc-management__scroll">
                <molecule-contract-item
                  v-for="(item, index) in contractList"
                  :key="index"
                  :data="item"
                  @click="selectRow"
                ></molecule-contract-item>
              </div>
            </div>
          </div>
        </div>
      </template>
    </molecule-dashboard-container>
    <!-- IDC DATABASE END -->
  </div>
</template>

<script>
import { BButtonGroup, BButton, BBadge, BTable, BTooltip } from "bootstrap-vue"
import MoleculeDashboardContainer from "@/components/molecules/MoleculeDashboardContainer.vue"
import MoleculeContractItem from "@/components/molecules/portal/idc/MoleculeContractItem.vue"
import AtomMultiLineChart from "@/components/atoms/graphs/AtomMultiLineChart.vue"
import AtomDoughnutChartV2 from "@/components/atoms/graphs/AtomDoughnutChartV2.vue"
import AtomDatepicker from "@/components/atoms/AtomDatepicker.vue"
import { mapActions } from "vuex"
import { DateTime } from "luxon"
import mixins from "@/mixins"

export default {
  name: "OrganismDashboard",
  components: {
    BButtonGroup,
    BButton,
    BBadge,
    MoleculeDashboardContainer,
    MoleculeContractItem,
    AtomMultiLineChart,
    AtomDoughnutChartV2,
    AtomDatepicker,
    BTable,
    BTooltip,
  },
  mixins: [mixins],
  props: {
    statusCountList: {
      type: Array,
      required: true,
    },
    isLoadingTicketPriority: {
      type: Boolean,
      required: true,
    },
    ticketPriorityCount: {
      type: Number,
      required: true,
    },
    ticketPriorityList: {
      type: Array,
      required: true,
    },
    // isLoadingInventory: {
    //   type: Boolean,
    //   required: true,
    // },
    // inventoryList: {
    //   type: Object,
    //   required: true,
    // },
    isLoadingNewEntry: {
      type: Boolean,
      required: true,
    },
    newEntryList: {
      type: Map,
      required: true,
    },
    isLoadingTicketEscalation: {
      type: Boolean,
      required: true,
    },
    ticketEscalationList: {
      type: Array,
      required: true,
    },
    isLoadingRecentChange: {
      type: Boolean,
      required: true,
    },
    recentChangeList: {
      type: Map,
      required: true,
    },
    isLoadingEntryStat: {
      type: Boolean,
      required: true,
    },
    entryStat: {
      type: Object,
      required: true,
    },
    isLoadingIdc: {
      type: Boolean,
      required: true,
    },
    idcData: {
      type: Object,
      required: true,
    },
  },
  emits: ["changeEntryStatTime", "changeIdcType"],
  data() {
    return {
      selectNewEntry: "ticket",
      selectRecentChange: "ticket",
      selectIdc: "recent",
      entryStatTimestampList: [],
      entryStatDataList: [],
      graphStatPeriod: {
        now: null,
        startDate: null,
        endDate: null,
      },
    }
  },
  computed: {
    buttonMenuName() {
      return [
        { topic: "Ticket", name: "ticket" },
        { topic: "Access", name: "access" },
        // { topic: "Smart Hand", name: "smartHand" },
        // { topic: "Parcel", name: "parcel" },
        // { topic: "XConnect", name: "xConnect" },
      ]
    },
    buttonMenuIdcName() {
      return [
        { topic: "Recent update", name: "recent" },
        { topic: "Waiting for Approval", name: "waiting" },
      ]
    },
    contractList() {
      if (this.selectIdc === "recent") return this.idcData.recentList
      if (this.selectIdc === "waiting") return this.idcData.waitingList
    },
    databaseTitle() {
      return this.selectIdc === "recent"
        ? `${this.contractLabel} Database 10 Recent Update`
        : `${this.contractLabel} Database Waiting for Approval`
    },
    badgeText() {
      return this.selectIdc !== "recent"
        ? `${this.contractList.length} Contract`
        : ""
    },
  },
  watch: {
    entryStat: {
      deep: true,
      handler() {
        this.setEntryStatData()
      },
    },
  },
  async mounted() {
    this.selectNewEntry = "ticket"
    this.selectRecentChange = "ticket"
    this.graphStatPeriod.now = DateTime.now().toISO()
    this.graphStatPeriod.startDate = DateTime.now().minus({ months: 1 }).toISO()
    this.graphStatPeriod.endDate = DateTime.now().toISO()
    await this.setEntryStatData()
  },
  methods: {
    ...mapActions("appFilter", ["setInternalParcelTrackingFilter"]),

    setEntryStatData() {
      this.entryStatTimestampList = this.entryStat.timestampList ?? []
      this.entryStatDataList = this.entryStat.dataList ?? []
    },

    onChangeEntryStatTime() {
      if (this.graphStatPeriod.startDate && this.graphStatPeriod.endDate) {
        this.$emit("changeEntryStatTime", this.graphStatPeriod)
      }
    },

    getStatusCountTitleOrIcon(name, isIcon = false) {
      switch (name) {
        case "ticket":
          return !isIcon ? "Ticket Tracking" : "TagIcon"

        case "access":
          return !isIcon ? "Site Access" : "MaximizeIcon"

        // case "smartHand":
        //   return !isIcon ? "Smart Hand" : "ThumbsUpIcon"

        // case "parcel":
        //   return !isIcon ? "Parcel Tracking" : "TruckIcon"

        // case "xConnect":
        //   return !isIcon ? "Cross Connect" : "LinkIcon"

        case "contract":
          return !isIcon ? "NTDC Contract" : "DatabaseIcon"
      }
    },

    getNewEntryMiddleColumnList(newEntry) {
      switch (this.selectNewEntry) {
        case "ticket":
          return [
            `Subject: ${newEntry.subject || "-"}`,
            `Detail: ${newEntry.detail || "-"}`,
          ]
        case "access":
          return [
            `Visitors: ${this.getFirstVisitorName(newEntry.visitors) || "-"}`,
            `Detail: ${newEntry.detail || "-"}`,
          ]

        // case "smartHand":
        //   return [
        //     `Job Title: ${newEntry.jobTitle || "-"}`,
        //     `Detail: ${newEntry.detail || "-"}`,
        //   ]

        // case "parcel":
        //   return [
        //     `Total Parcel: ${newEntry.totalParcel || "-"}`,
        //     `วันที่ส่งของ: ${newEntry.sentDate || "-"}`,
        //   ]

        // case "xConnect":
        //   return [
        //     `Origin: ${newEntry.origin || "-"}`,
        //     `Destination: ${newEntry.destination || "-"}`,
        //   ]
      }
    },

    getFirstVisitorName(visitors) {
      return visitors.length === 1
        ? visitors[0]
        : `${visitors[0]} +${visitors.length - 1}`
    },

    getEscalationEscalateLevel(ticketEscalation) {
      return [`Escalate to Level: ${ticketEscalation.level}`]
    },

    getEscalationSubjectAndLastReply(ticketEscalation) {
      return [
        `Subject: ${ticketEscalation.subject}`,
        `${ticketEscalation.lastReply}`,
      ]
    },

    getEscalateColumnList(ticketEscalation) {
      return [
        `By: ${ticketEscalation.escalateBy}`,
        `Current: ${ticketEscalation.current}`,
      ]
    },

    getRecentChangeMiddleColumnList(recentChange) {
      switch (this.selectRecentChange) {
        case "ticket":
          return [
            `Subject: ${recentChange.subject}`,
            `${recentChange.staff}: ${recentChange.activity}`,
          ]
        case "access":
          return [
            `Visitors: ${
              this.getFirstVisitorName(recentChange.visitors) || "-"
            }`,
            `First Check In: ${
              recentChange.firstCheckIn ? recentChange.firstCheckIn : "-"
            }`,
            `Last Check Out: ${
              recentChange.lastCheckout ? recentChange.lastCheckout : "-"
            }`,
          ]

        // case "smartHand":
        //   return [
        //     `Job Title: ${recentChange.jobTitle}`,
        //     `${recentChange.department}: ${recentChange.activity}`,
        //   ]

        // case "parcel":
        //   return [
        //     `Received By: ${recentChange.receivedBy || "-"}`,
        //     `Received Date: ${recentChange.receiveDate || "-"}`,
        //   ]

        // case "xConnect":
        //   return [
        //     `${recentChange.staff}: ${recentChange.activity}`,
        //     `Origin: ${recentChange.origin}  Destination: ${recentChange.destination}`,
        //   ]
      }
    },

    getVariantMenuNewEntry(name) {
      return this.selectNewEntry === name
        ? "outline-primary"
        : "outline-secondary"
    },

    getVariantMenuRecentChange(name) {
      return this.selectRecentChange === name
        ? "outline-primary"
        : "outline-secondary"
    },

    getVariantMenuIdc(name) {
      return this.selectIdc === name ? "outline-primary" : "outline-secondary"
    },

    getVariantEntryTime(time) {
      return this.selectEntryStatTime === time
        ? "outline-primary"
        : "outline-secondary"
    },

    getStatus(status) {
      switch (status) {
        case "OPENED":
          return "Opened"

        case "WAITING":
          return "Waiting"

        case "APPROVED":
          return "Approved"

        case "REJECTED":
          return "Rejected"

        case "IN_PROGRESS":
          return "In Progress"

        case "RECEIVED":
          return "Received"

        case "COMPLETED":
          return "Completed"

        case "DECLINED":
          return "Declined"

        case "CLOSED":
          return "Closed"

        case "ACCESS":
          return "Access"
      }
    },

    getVariantForStatus(status) {
      switch (status) {
        case "OPENED":
          return "light-primary"

        case "WAITING":
          return "light-primary"

        case "APPROVED":
          return "light-success"

        case "REJECTED":
          return "light-danger"

        case "IN_PROGRESS":
          return "light-warning"

        case "RECEIVED":
          return "light-success"

        case "COMPLETED":
          return "light-success"

        case "DECLINED":
          return "light-danger"

        case "CLOSED":
          return "light-secondary"

        case "ACCESS":
          return "light-primary"
      }
    },

    getVariantForStatusParcel(status) {
      switch (status) {
        case "WAITING":
          return "light-warning"

        case "APPROVED":
          return "light-success"

        case "REJECTED":
          return "light-danger"

        case "RECEIVED":
          return "light-success"

        case "CLOSED":
          return "light-secondary"

        case "ACCESS":
          return "light-primary"
      }
    },

    badgeVariant(status) {
      if (status === "PENDING") return "light-info"
      if (status === "APPROVED") return "light-success"
      if (status === "DELETED") return "light-danger"
      if (status === "SUSPENDED") return "light-warning"
      return null
    },

    badgeStatus(status) {
      if (status === "PENDING") return "Pending"
      if (status === "APPROVED") return "Approved"
      if (status === "DELETED") return "Deleted"
      if (status === "SUSPENDED") return "Suspended"
      return null
    },

    setPathDetail(menu) {
      if (menu === "ticket") return "ticket"
      if (menu === "access") return "site-access"
      // if (menu === "smartHand") return "smart-hand"
      // if (menu === "parcel") return "parcel-tracking"
      // return "cross-connect"
    },

    clickRowTicketEscalation(ticketEscalation) {
      this.$router.push(`/internal/web-portal/ticket/${ticketEscalation.id}`)
    },

    clickRow(menu, row) {
      this.$router.push(
        `/internal/web-portal/${this.setPathDetail(menu)}/${row.id}`
      )
      // if (menu === "parcel") {
      //   const defaultFilter = {
      //     trackingId: row.id,
      //     customerName: "",
      //     idcId: "",
      //     status: [],
      //     dataType: "",
      //     dateTime: {
      //       start: DateTime.now().startOf("day").toISO(),
      //       end: DateTime.now().toISO(),
      //       now: DateTime.now().toISO(),
      //     },
      //     isEnableDate: false,
      //     totalCount: 0,
      //     currentPage: 1,
      //   }
      //   this.setInternalParcelTrackingFilter(defaultFilter)
      //   this.$router.push(`/internal/web-portal/${this.setPathDetail(menu)}`)
      // } else {
      //   this.$router.push(
      //     `/internal/web-portal/${this.setPathDetail(menu)}/${row.id}`
      //   )
      // }
    },

    onChangeIdcType(type) {
      this.selectIdc = type

      this.$emit("changeIdcType", type)
    },

    selectRow(record) {
      this.$router.push("/internal/web-portal/idc/contract/" + record.id)
    },
  },
}
</script>

<style lang="scss" scoped>
.alert__icon-info {
  color: #b9b9c3;
  &:hover {
    cursor: pointer;
  }
}

.alert__icon-level {
  color: #ff9f43;
  margin-left: 12px;
  &:hover {
    cursor: pointer;
  }
}

.textbox__warning-value--style {
  color: #ff9f43;
  text-align: center;
}

.dashboard__row-2 {
  .row-2__item-1 {
    width: 100%;
  }

  .row-2__item-2 {
    width: 100%;
  }
}
.status-count__card {
  min-width: 150px;
  width: 100%;
}

.text-status-count {
  color: #6e6b7b;
  font-weight: 400;
  font-size: 12px;
  margin-bottom: 4px;
}

.text-count-open {
  text-shadow: 0px 4px 5px rgba(0, 0, 0, 0.2);
  color: #7367f0;
  font-weight: 700;
  font-size: 24px;
}

.text-count-in-progress {
  color: #6e6b7b;
  font-weight: 600;
  font-size: 24px;
}

.card__container {
  padding: 12px 18px;
  background: #ffffff;
  border-radius: 6px;
  box-shadow: 0px 4px 24px rgba(0, 0, 0, 0.06);
}

.container__body {
  height: 400px;
  overflow-y: auto;
  padding: 0 14px;
}

.text-company {
  color: #6e6b7b;
  font-weight: 500;
}

.text-idc {
  color: #b9b9c3;
  font-weight: 400;
}

.text-normal {
  color: #6e6b7b;
  font-weight: 400;
  display: block;
  overflow-wrap: break-word;
  word-break: break-word;
}

.text-date {
  color: #6e6b7b;
}

.text-time {
  color: #b9b9c3;
  font-weight: 400;
  margin-bottom: 0;
  margin-left: 6px;
}

.btn {
  padding: 4px 6px;
  font-size: 12px;
}

.status-count__container {
  display: grid;
  gap: 14px;
  grid-template-columns: auto;
}

.ticket-priority__count {
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10;
  height: 100%;
  width: 100%;
}

.ticket-priority__text-count {
  color: #5e5873;
  font-weight: 500;
  font-size: 18px;
}

.ticket-priority__text {
  color: #6e6b7b;
  font-weight: 400;
  font-size: 12px;
}

.ticket-priority__text-value,
.ticket-priority__text-name {
  color: #5e5873;
  font-weight: 700;
  font-size: 14px;
}
.ticket-priority__text-name {
  font-weight: 500;
  width: 62px;
}

.icon_folder {
  width: 70px;
  height: 70px;
}

.idc__text-bold {
  color: #6e6b7b;
  font-weight: 600;
  font-size: 14px;
}

.idc__text-normal {
  color: #6e6b7b;
  font-weight: 400;
  font-size: 14px;
  display: block;
  overflow-wrap: break-word;
  word-break: break-word;
}

.idc__text-small {
  color: #6e6b7b;
  font-weight: 400;
  font-size: 12px;
}

.height-inventory {
  height: 230px;
}

.height-new-entry {
  height: 385px;
}

.height-graph {
  height: 385px;
}

.text-inventory-subject {
  font-weight: 400;
  font-size: 8px;
  color: #6e6b7b;
}

.text-inventory-name {
  color: #6e6b7b;
  font-weight: 400;
  font-size: 14px;
}

.text-inventory-type {
  color: #6e6b7b;
  font-weight: 400;
  font-size: 10px;
}

.text-inventory-ma-date {
  font-weight: 400;
  font-size: 14px;
}

.width-graph {
  width: 100%;
}

.height-button-group {
  height: 34px;
}

.width-sm-100,
.width-md-100 {
  width: 100%;
}

.priority-container {
  max-width: 100px;
  display: flex;
  justify-content: center;
}

.priority__critical {
  font-weight: 600;
  font-size: 14px;
  color: #ea5455;
}

.priority__high {
  font-size: 14px;
  color: #ea5455;
}

.priority__medium {
  font-size: 14px;
  color: #ff9f43;
}

.priority__low {
  font-size: 14px;
  color: #28c76f;
}

.entry__item:hover {
  background-color: #7367f00a;
  cursor: pointer;
}

.badge--width {
  margin-top: 3px;
}

// Small devices (landscape phones, 576px and up)
@media (min-width: 576px) {
  .status-count__container {
    grid-template-columns: auto auto;
  }
}

// Medium devices (tablets, 768px and up)
@media (min-width: 768px) {
  .dashboard__row-2 {
    display: flex;

    .row-2__item-1 {
      width: 262px;
    }

    .row-2__item-2 {
      padding-left: 14px;
      width: calc(100% - 262px);
    }
  }
  .status-count__container {
    grid-template-columns: auto auto auto;
  }

  .btn {
    padding: 10px 14px;
  }

  .width-sm-100 {
    width: auto;
  }
}

// Large devices (desktops, 992px and up)
@media (min-width: 992px) {
  .height-new-entry {
    height: 533px;
  }

  .height-graph {
    height: 350px;
  }

  .height-lg-34px {
    height: 34px;
  }

  .width-md-100 {
    width: auto;
  }
}

// X-Large devices (larger desktops, 1140px and up)
@media (min-width: 1400px) {
  .width-graph {
    width: 50%;
  }

  .p-xl-l-7px {
    padding-left: 7px;
  }

  .p-xl-r-7px {
    padding-right: 7px;
  }
}

.organism-idc-management__scroll {
  overflow: auto;
  height: 400px;
  width: 100%;
  max-height: 100vh;
}

// XX-Large devices (larger desktops, 1400px and up)
@media (min-width: 1400px) {
  .status-count__container {
    grid-template-columns: auto auto auto auto auto auto;
  }
}
</style>
